// eslint-disable-next-line import/prefer-default-export
export const QUERY_FILE = {
  parser: {
    support: '.json,.xml', // RXFE-5036: .txt is only valid for batch searching
  },
};
